import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'bingo-countdown-bar-pagination',
  templateUrl: './countdown-bar-pagination.html',
  styleUrl: './countdown-bar-pagination.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountdownBarPaginationComponent {
  protected readonly dots = computed<number[]>(() => Array.from({ length: this.count() }, (_, index) => index));
  readonly count = input.required<number>();
  readonly activeIndex = input.required<number>();
  readonly selectIndex = output<number>();
}
